/**
 * Onboarding welcome: self-serve vs white-glove choice.
 * Plan: billing_infrastructure_plan §1.8. First screen after approval.
 */
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function OnboardingWelcome() {
  const navigate = useNavigate();

  return (
    <Card className="max-w-md mx-auto">
      <CardHeader>
        <CardTitle>Get started</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        <Button
          data-testid="btn-do-myself"
          onClick={() => navigate('/app/onboarding')}
        >
          I'll Do It Myself
        </Button>
        <Button
          data-testid="btn-white-glove"
          variant="outline"
          onClick={() => navigate('/app/onboarding/white-glove/intake')}
        >
          Set It Up For Me
        </Button>
      </CardContent>
    </Card>
  );
}
